import {Directive, effect, ElementRef, inject, input} from '@angular/core';
import {ColorComponents, Utilities} from '@xmedical/core';

@Directive({
    selector: '[xuiInvertTextColor]',
})
export class InvertTextColorDirective {
  xuiInvertTextColor = input<string>('');

  private readonly element: HTMLElement = inject(ElementRef).nativeElement;

  constructor() {
    effect(() => {
      const inputColor = this.xuiInvertTextColor();
      const bgColor = this.resolveBackgroundColor(inputColor);
      if (!bgColor) {
        return;
      }
      const bgComponents = this.colorStringToColorComponents(bgColor);
      const textColor = this.getCssColor(bgComponents);
      this.element.style.color = textColor;
      this.element.style.backgroundColor = bgColor;
    });
  }

  private resolveBackgroundColor(inputColor: string): string | null {
    if (inputColor) {
      return inputColor;
    }
    const computed = window.getComputedStyle(this.element).backgroundColor;
    if (!computed || computed === 'transparent' || computed === 'rgba(0, 0, 0, 0)') {
      return null;
    }
    return computed;
  }

  private colorStringToColorComponents(colourString: string): ColorComponents {
    if (colourString && colourString.indexOf('#') === 0) { return  Utilities.hexToRgb(colourString); }
    if (colourString && colourString.indexOf('rgb') === 0) { return Utilities.stringToRgb(colourString); }
    return {r: 255, b: 255, g: 255, a: 1 };
  }

  private getCssColor(backgroundColorComponents: ColorComponents): string {
    const red = backgroundColorComponents.r;
    const green = backgroundColorComponents.g;
    const blue = backgroundColorComponents.b;
    const redPrime = red / 255;
    const greenPrime = green / 255;
    const bluePrime = blue / 255;
    const colorMax = Math.max(redPrime, greenPrime, bluePrime);
    const colorMin = Math.min(redPrime, greenPrime, bluePrime);
    const lightness = (colorMax + colorMin) / 2;
    return lightness >= 0.50 ? 'black' : 'white';
  }
}
